export const types = {
  RESEND_VERIFICATION: 'verification',
  AB_TESTING_SEGMENT:'ABTestingSegment'
};

